<div [class.notDragging]="!currentlyDragged" [class.pendingDelete]="pendingDelete">
  <div class="button" #button>
    <div class="iconContainer">
      <mat-icon>delete</mat-icon>
    </div>
  </div>
  <div #draggableElement class="text" (touchstart)="touchStart($event)" (touchend)="touchEnd()" (touchcancel)="this.currentlyDragged = false" (touchmove)="move($event)"><ng-content></ng-content></div>
</div>

